


















































import { Component, Inject, Vue } from 'vue-property-decorator';
import { AxiosInstance } from 'axios';
import { validationMixin } from 'vuelidate';
import { required, minLength, sameAs } from 'vuelidate/lib/validators';
import { Breadcrumbs as BreadcrumbsLayout } from '@/components/layout';
import { Spinner as LoadingSpinner } from '@/components/spinners';
import { inviteService } from '@/services';
import { InviteForm, FormInviteWrapper } from '@/components/page/invite';
import { FormInput } from '@/pages/profile/blocks/form';
import Button from '@/pages/profile/components/button';
import { AppHeading, AppText } from '@/uikit/';
import { Passwords } from './types';
import { ACTIONS } from '@/store/user';

@Component({
  components: {
    BreadcrumbsLayout,
    LoadingSpinner,
    FormInviteWrapper,
    InviteForm,
    FormInput,
    Button,
    AppHeading,
    AppText,
  },

  mixins: [validationMixin],
})
export default class Invite extends Vue {
  @Inject() $api: AxiosInstance;
  @Inject() $config: any;

  code: string = '';
  loading: boolean = true;
  invitedName: string = '';
  invitedEmail: string = '';
  errors: string = '';
  passwords: Passwords = {
    newPassword: '',
    comparePassword: '',
  };

  validations() {
    const passwords: any = {
      newPassword: {
        required,
        minLength: minLength(6),
      },
      comparePassword: {
        sameAsPassword: sameAs('newPassword'),
      },
    };

    return { passwords };
  }

  get isDisabled() {
    return (this as any).$v.passwords.$invalid;
  }

  get crumbs() {
    return [
      {
        text: 'Главная',
        to: { path: '/' },
      },
      {
        text: 'Задать пароль от нового аккаунта',
      },
    ];
  }

  async mounted() {
    const { code } = this.$route.query;

    if (!code) return;
    this.code = code;
    try {
      const { data } = await inviteService(this.$api).getSearchInvite(code);
      this.invitedName = data.invited_fio;
      this.invitedEmail = data.email;
    } catch (error) {
      this.setErrors(error);
    } finally {
      this.loading = false;
    }
  }

  async submit() {
    const { code, passwords, $api } = this;
    (this as any).$v.passwords.$touch();
    if (this.isDisabled && !code.length) return;
    this.loading = true;

    try {
      await inviteService($api).postRegisterInvite({
        code,
        password: passwords.newPassword,
      });
      this.loginInvited();
    } catch (error) {
      this.loading = false;
      this.setErrors(error);
    }
  }

  async loginInvited() {
    const { invitedEmail, passwords } = this;
    await this.$store.dispatch(`user/${ACTIONS.SIGNIN}`, {
      email: invitedEmail,
      password: passwords.newPassword,
    });

    this.$store.commit('user/setNube', true);
  }

  setErrors(error: any) {
    const { errors, err_code } = error.response.data;
    if (err_code === 400) {
      const [{ msg }] = errors;
      this.errors = msg || this.$config.errors;
    } else {
      this.errors = this.$config.errors;
    }
  }
}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/invite/Invite.vue